import { render, staticRenderFns } from "./neteaseIdMatch.vue?vue&type=template&id=74ac04b6&scoped=true&"
import script from "./neteaseIdMatch.vue?vue&type=script&lang=js&"
export * from "./neteaseIdMatch.vue?vue&type=script&lang=js&"
import style0 from "./neteaseIdMatch.vue?vue&type=style&index=0&id=74ac04b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ac04b6",
  null
  
)

export default component.exports